import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { ActionsRequisesDtoActionsRequisesEnum } from 'lib_api/lib/api/gen';

import { FilterDashboardAutoriteFourriere } from 'pages/autorite-fourriere/Dashboard/DashboardHeader/Filters/types';

interface AFFilterContextContent {
  filter: Partial<FilterDashboardAutoriteFourriere>;
  setFilter: Dispatch<
    SetStateAction<Partial<FilterDashboardAutoriteFourriere>>
  >;
  // all actions requises configured for af users
  actionsRequises: ActionsRequisesDtoActionsRequisesEnum[] | undefined;
}

const AFFilterContext = createContext<AFFilterContextContent | null>(null);

export const useAFFilterContext = (): [
  Partial<FilterDashboardAutoriteFourriere>,
  Dispatch<SetStateAction<Partial<FilterDashboardAutoriteFourriere>>>,
  ActionsRequisesDtoActionsRequisesEnum[] | undefined,
] => {
  const context = useContext(AFFilterContext);
  if (context === null) {
    throw new Error('useFilterContext called outside Context.');
  }

  return [context.filter, context.setFilter, context.actionsRequises];
};

const AFFilterProvider = AFFilterContext.Provider;

export default AFFilterProvider;
